/**
 * Точки GPS для отладочной записи Следа в веб-клиенте (этап 1, без телефона).
 *
 * Повторяет логику server tests: 60 секунд в соте → Верный След.
 */

import { cellToLatLng } from "h3-js";

export function buildDebugTracePoints(
  hexId: string,
  durationSec = 60,
  stepSec = 15,
): Array<{ lat: number; lng: number; accuracy: number; recordedAt: string }> {
  const [lat, lng] = cellToLatLng(hexId);
  const start = Date.now() - durationSec * 1000;
  const count = Math.floor(durationSec / stepSec) + 1;
  return Array.from({ length: count }, (_, index) => ({
    lat,
    lng,
    accuracy: 10,
    recordedAt: new Date(start + index * stepSec * 1000).toISOString(),
  }));
}
